import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import mardeolivosfondo from "../assets/theme-images/mardeolivosfondo.png";
import Navbar from "../components/Navbar/Navbar";

const categories = [
  { key: 0, nombre: "Productos Extra", id: "extra" },
  { key: 1, nombre: "Ligoteo", id: "ligoteo" },
  { key: 2, nombre: "Para compartir", id: "paracompartir" },
  { key: 3, nombre: "Postres", id: "postres" },
  { key: 4, nombre: "Arroces", id: "arroces" },
  { key: 5, nombre: "Vinos", id: "vinos" },
  { key: 6, nombre: "Alergenos", id: "alergenos" },
];

export default function Menu() {
  const [productos, setProductos] = useState([]);
  const [hoveredProducto, setHoveredProducto] = useState(null);
  const [cartaActiva, setCartaActiva] = useState(null);
  const [isDesktop, setIsDesktop] = useState(
    typeof window !== "undefined" ? window.innerWidth >= 1024 : false,
  );

  const [showAnimated, setShowAnimated] = useState(false);
  const [showText, setShowText] = useState(false);

  const [showHouse, setShowHouse] = useState(false);
  const sectionRefs = useRef({});
  const [activeCat, setActiveCat] = useState(1);
  const navRef = useRef(null);

  // ✅ NUEVO: confeti veraniego al pulsar el botón flotante
  const [summerBurst, setSummerBurst] = useState([]);
  const summerBtnRef = useRef(null);

  const spawnSummerConfetti = () => {
    const idBase = Date.now();

    // Origen: centro del botón flotante
    let x0 = typeof window !== "undefined" ? window.innerWidth - 70 : 300;
    let y0 = typeof window !== "undefined" ? window.innerHeight - 70 : 600;

    const rect = summerBtnRef.current?.getBoundingClientRect?.();
    if (rect) {
      x0 = rect.left + rect.width / 2;
      y0 = rect.top + rect.height / 2;
    }

    const emojis = ["🍋", "🫒", "✨"];
    const count = 22;

    const newOnes = Array.from({ length: count }).map((_, i) => {
      const emoji = emojis[Math.floor(Math.random() * emojis.length)];
      const dx = (Math.random() * 320 + 80) * -1; // hacia arriba/izq
      const dy = (Math.random() * 380 + 180) * -1;

      return {
        id: idBase + i,
        x0,
        y0,
        dx,
        dy,
        dy2: dy + (40 + Math.random() * 90),
        rot: Math.random() * 220 - 110,
        s: 0.8 + Math.random() * 1.1,
        dur: 1.0 + Math.random() * 0.8,
        delay: Math.random() * 0.06,
        size: 16 + Math.random() * 18,
        emoji,
      };
    });

    setSummerBurst((prev) => [...prev, ...newOnes]);

    // limpiar partículas
    setTimeout(() => {
      setSummerBurst((prev) => prev.filter((p) => p.id < idBase));
    }, 2600);
  };

  // Detectar cambio de tamaño para isDesktop
  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Carga de productos
  useEffect(() => {
    fetch("https://mardeolivosceuta.es/api/get_productos.php")
      .then((res) => res.json())
      .then((data) => setProductos(data))
      .catch((err) => console.error("Error fetching products:", err));
  }, []);

  // Agrupar productos por categoría
  const productosPorCategoria = productos.reduce((acc, prod) => {
    if (prod.disponible === 1) {
      acc[prod.categoria] = acc[prod.categoria] || [];
      acc[prod.categoria].push(prod);
    }
    return acc;
  }, {});

  // IntersectionObserver para resaltar nav activo
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) =>
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveCat(Number(entry.target.dataset.key));
          }
        }),
      { rootMargin: "-60% 0px -40% 0px", threshold: 0 },
    );
    categories.forEach((cat) => {
      const el = sectionRefs.current[cat.key];
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  // Smooth scroll con offset nav
  const scrollToCategory = (key) => {
    const el = sectionRefs.current[key];
    const navHeight = navRef.current?.offsetHeight || 0;
    if (el) {
      window.scrollTo({
        top: el.offsetTop - navHeight - 10,
        behavior: "smooth",
      });
    }
  };

  // Hint animation: mostramos el botón + texto animado, y luego desaparece el texto dejando solo el botón
  useEffect(() => {
    setShowHouse(true);
    setShowAnimated(true);

    const timer = setTimeout(() => {
      setShowAnimated(false);
      setShowText(false);
    }, 8200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      <Navbar />
      <div
        className="w-full bg-fixed bg-cover bg-center"
        style={{
          backgroundImage: `url(${mardeolivosfondo})`,
          backgroundColor: "#fdfaf4",
        }}
      >
        {/* Navbar categorías */}
        <nav
          ref={navRef}
          className="fixed top-12 left-0 right-0 z-50 bg-white/75 shadow-md"
        >
          <div className="h-1 bg-[#ba913d] w-full" />
          <div className="flex justify-start md:justify-center items-center gap-6 px-4 py-2 overflow-x-auto whitespace-nowrap border-b-2">
            {categories.map((cat) => (
              <button
                key={cat.key}
                onClick={() => scrollToCategory(cat.key)}
                className={`inline-block text-lg font-semibold pb-1 transition ${
                  activeCat === cat.key
                    ? "text-[#ba913d] border-b-2 border-[#ba913d]"
                    : "text-[#503a2c]"
                }`}
              >
                {cat.nombre}
              </button>
            ))}
          </div>
        </nav>

        {/* Espaciador */}
        <div className="h-24" />

        {/* Secciones con productos */}
        <div className="max-w-6xl mx-auto">
          {/* FUERA DE CARTA (solo si hay categoría 7) */}
          {(productosPorCategoria[7]?.length ?? 0) > 0 && (
            <section id="fuera-de-carta" className="w-full pt-2">
              <div className="w-full bg-white/70 shadow-lg backdrop-blur-sm overflow-hidden">
                <div className="px-6 py-1 bg-white/75 border-t-2 border-b-2 border-t-[#C19B50] border-b-[#C19B50]">
                  <h2 className="text-3xl font-bold text-[#503a2c]">
                    Fuera de carta
                  </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-2 md:p-0">
                  {productosPorCategoria[7].map((producto, idx) => (
                    <motion.div
                      key={producto.id}
                      className="flex items-center p-3 cursor-pointer bg-white/75 border-t-2 border-b-2 border-t-[#C19B50] border-b-[#C19B50] md:border md:border-[#C19B50] md:border-t md:border-b h-full"
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{
                        delay: idx * 0.1,
                        duration: 0.5,
                        ease: "easeInOut",
                      }}
                      onMouseEnter={() => setHoveredProducto(producto)}
                      onMouseLeave={() => setHoveredProducto(null)}
                      onClick={() => !cartaActiva && setCartaActiva(producto)}
                    >
                      <img
                        src={`https://mardeolivosceuta.es/${producto.imagen}`}
                        alt={producto.nombre}
                        className="w-24 h-24 object-cover rounded-md"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = "/img/plato.jpeg";
                        }}
                      />
                      <div className="flex-1 px-4">
                        <h3 className="text-xl font-semibold text-[#503a2c] line-clamp-2">
                          {producto.nombre}
                        </h3>
                        <p className="text-sm text-black line-clamp-3">
                          {producto.descripcion}
                        </p>
                        <p className="text-xs italic text-gray-500 mb-1 line-clamp-2">
                          {producto.alergenos}
                        </p>
                        <p className="text-sm text-[#ba913d]">
                          {parseFloat(producto.precio_media) > 0
                            ? `Media: ${parseFloat(
                                producto.precio_media,
                              ).toFixed(2)}€ · Ración: ${parseFloat(
                                producto.precio,
                              ).toFixed(2)}€`
                            : `${parseFloat(producto.precio).toFixed(2)}€`}
                        </p>
                      </div>
                    </motion.div>
                  ))}
                </div>
              </div>
            </section>
          )}

          {categories.map((cat) => (
            <section
              key={cat.key}
              id={cat.id}
              data-key={cat.key}
              ref={(el) => (sectionRefs.current[cat.key] = el)}
              className="w-full pt-2"
            >
              {cat.key === 6 ? (
                <div className="w-full bg-white/70 rounded-3xl shadow-lg backdrop-blur-sm p-6">
                  <h2 className="text-3xl font-bold text-center mb-4 text-[#503a2c]">
                    Alérgenos
                  </h2>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-lg text-[#503a2c]">
                    <p>🌾 Contiene gluten (trigo, cebada o avena).</p>
                    <p>🥛 Contiene lácteos o derivados de la leche.</p>
                    <p>🥜 Contiene frutos secos como almendras o nueces.</p>
                    <p>🥚 Contiene huevo o trazas.</p>
                    <p>🦐 Contiene mariscos (crustáceos o moluscos).</p>
                    <p>🐟 Contiene pescado o derivados del mar.</p>
                    <p>
                      🌱 Contiene soja u otros ingredientes vegetales
                      específicos.
                    </p>
                    <p>💨 Contiene sulfitos (conservantes).</p>
                    <p>🌿 Contiene apio (presente en sopas o guisos).</p>
                    <p>🌰 Contiene mostaza (común en aliños).</p>
                    <p>🫘 Contiene altramuces (usado en harinas).</p>
                    <p>
                      🧂 Puede contener exceso de sal o ingredientes salados.
                    </p>
                  </div>
                </div>
              ) : (
                <div className="w-full bg-white/70 shadow-lg backdrop-blur-sm overflow-hidden">
                  <div className="px-6 py-1 bg-white/75 border-t-2 border-b-2 border-t-[#C19B50] border-b-[#C19B50]">
                    <h2 className="text-3xl font-bold text-[#503a2c]">
                      {cat.nombre}
                    </h2>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-2 md:p-0">
                    {productosPorCategoria[cat.key]?.map((producto, idx) => (
                      <motion.div
                        key={producto.id}
                        className="flex items-center p-3 cursor-pointer bg-white/75 border-t-2 border-b-2 border-t-[#C19B50] border-b-[#C19B50] md:border md:border-[#C19B50] md:border-t md:border-b h-full"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{
                          delay: idx * 0.1,
                          duration: 0.5,
                          ease: "easeInOut",
                        }}
                        onMouseEnter={() => setHoveredProducto(producto)}
                        onMouseLeave={() => setHoveredProducto(null)}
                        onClick={() => !cartaActiva && setCartaActiva(producto)}
                      >
                        <img
                          src={`https://mardeolivosceuta.es/${producto.imagen}`}
                          alt={producto.nombre}
                          className="w-24 h-24 object-cover rounded-md"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/img/plato.jpeg";
                          }}
                        />
                        <div className="flex-1 px-4">
                          <h3 className="text-xl font-semibold text-[#503a2c] line-clamp-2">
                            {producto.nombre}
                          </h3>
                          <p className="text-sm text-black line-clamp-3">
                            {producto.descripcion}
                          </p>
                          <p className="text-xs italic text-gray-500 mb-1 line-clamp-2">
                            {producto.alergenos}
                          </p>
                          <p className="text-sm text-[#ba913d]">
                            {parseFloat(producto.precio_media) > 0
                              ? `Media: ${parseFloat(
                                  producto.precio_media,
                                ).toFixed(2)}€ · Ración: ${parseFloat(
                                  producto.precio,
                                ).toFixed(2)}€`
                              : `${parseFloat(producto.precio).toFixed(2)}€`}
                          </p>
                        </div>
                      </motion.div>
                    ))}
                  </div>
                </div>
              )}
            </section>
          ))}
        </div>

        {/* Preview hover sólo escritorio */}
        {isDesktop && (
          <AnimatePresence>
            {hoveredProducto && (
              <motion.div
                key={hoveredProducto.id}
                className="fixed w-[300px] h-[300px] rounded-2xl shadow-lg overflow-hidden z-40"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
                style={{ top: hoveredProducto.top || 100, right: 40 }}
              >
                <img
                  src={`https://mardeolivosceuta.es/${hoveredProducto.imagen}`}
                  alt={hoveredProducto.nombre}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "/img/plato.jpeg";
                  }}
                  className="w-full h-full object-cover"
                />
              </motion.div>
            )}
          </AnimatePresence>
        )}

        {/* Modal producto sólo móvil */}
        {!isDesktop && (
          <AnimatePresence>
            {cartaActiva && (
              <motion.div
                className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm flex items-center justify-center"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                onClick={() => setCartaActiva(null)}
              >
                <motion.div
                  className="relative bg-white rounded-3xl overflow-hidden w-[90vw] max-h-[90vh] flex flex-col"
                  initial={{ scale: 0.8 }}
                  animate={{ scale: 1 }}
                  exit={{ scale: 0.8 }}
                  transition={{ duration: 0.3, ease: "easeInOut" }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    onClick={() => setCartaActiva(null)}
                    className="absolute top-2 right-2 bg-red-600 text-white rounded-full w-8 h-8 flex items-center justify-center z-10"
                  >
                    ✕
                  </button>
                  <img
                    src={`https://mardeolivosceuta.es/${cartaActiva.imagen}`}
                    alt={cartaActiva.nombre}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "/img/plato.jpeg";
                    }}
                    className="object-cover w-full h-64"
                  />
                  <div className="p-6 overflow-auto">
                    <h3 className="text-2xl font-bold text-[#503a2c] mb-4">
                      {cartaActiva.nombre}
                    </h3>
                    <p className="text-base text-gray-700 mb-4">
                      {cartaActiva.descripcion}
                    </p>
                    {parseFloat(cartaActiva.precio_media) > 0 && (
                      <p className="text-base text-[#ba913d] mb-2">
                        Media: {parseFloat(cartaActiva.precio_media).toFixed(2)}
                        €
                      </p>
                    )}
                    <p className="text-base text-[#ba913d]">
                      Ración: {parseFloat(cartaActiva.precio).toFixed(2)}€
                    </p>
                  </div>
                </motion.div>
              </motion.div>
            )}
          </AnimatePresence>
        )}
      </div>

      {/* ✅ Hint animación: confeti veraniego + texto; click => explota 🍋🫒✨ */}
      <AnimatePresence>
        {showHouse && (
          <>
            {/* Partículas (confeti veraniego) */}
            <AnimatePresence>
              {summerBurst.map((p) => (
                <motion.span
                  key={p.id}
                  className="fixed z-[90] pointer-events-none select-none"
                  style={{ left: p.x0, top: p.y0, fontSize: p.size }}
                  initial={{ opacity: 0, x: 0, y: 0, scale: 0.85, rotate: 0 }}
                  animate={{
                    opacity: [0, 1, 1, 0],
                    x: p.dx,
                    y: [0, p.dy, p.dy2],
                    scale: [0.85, p.s, p.s * 0.95],
                    rotate: p.rot,
                  }}
                  exit={{ opacity: 0 }}
                  transition={{
                    duration: p.dur,
                    delay: p.delay,
                    ease: "easeOut",
                  }}
                >
                  {p.emoji}
                </motion.span>
              ))}
            </AnimatePresence>

            {/* Botón flotante */}
            <motion.div
              className="fixed bottom-4 right-4 flex items-center space-x-2 rounded-full p-2 z-50"
              initial={{ opacity: 0, x: 50 }}
              animate={{
                opacity: 1,
                x: 0,
                background:
                  "linear-gradient(90deg, rgba(193, 155, 80, 0.95) 0%, rgba(80, 58, 44, 0.75) 100%)",
              }}
              exit={{ opacity: 0, x: 50 }}
              transition={{ duration: 0.6, ease: "easeInOut" }}
            >
              {/* Botón limón (sin navegación) */}
              <button
                ref={summerBtnRef}
                type="button"
                onClick={spawnSummerConfetti}
                aria-label="Lanzar confeti veraniego"
                className="h-12 w-12 grid place-items-center rounded-full bg-white/80 border-2 border-[#C19B50] shadow-md active:scale-95"
              >
                <motion.span
                  className="text-2xl"
                  initial={{ rotate: 0, scale: 1 }}
                  whileTap={{ scale: 0.9, rotate: -10 }}
                  animate={{
                    rotate: [0, 8, -8, 6, -6, 0],
                    scale: [1, 1.08, 1],
                  }}
                  transition={{
                    rotate: {
                      duration: 1.8,
                      repeat: Infinity,
                      ease: "easeInOut",
                    },
                    scale: {
                      duration: 1.2,
                      repeat: Infinity,
                      ease: "easeInOut",
                    },
                  }}
                >
                  🍋
                </motion.span>
              </button>

              {/* Texto animado (solo durante la intro) */}
              {showAnimated ? (
                <motion.span
                  className="px-4 py-2 rounded-full whitespace-nowrap text-white font-semibold"
                  initial={{ opacity: 0, x: 20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.2, duration: 0.7, ease: "easeInOut" }}
                >
                  ¡Púlsame y cae confeti! ✨
                </motion.span>
              ) : null}
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
}
